import React from 'react'
import { DASHBOARD_LEFT_CARDS, DASHBOARD_RIGHT_CARDS } from 'app-constants'
import './style.scss'

export function ServiceCards() {
  function renderLeftCards() {
    return DASHBOARD_LEFT_CARDS.map(Component => <Component />)
  }

  function renderRightCards() {
    return DASHBOARD_RIGHT_CARDS.map(Component => <Component />)
  }

  return (
    <div className='container-service-cards'>
      <div className='container left'>{renderLeftCards()}</div>
      <div className='container right'>{renderRightCards()}</div>
    </div>
  )
}
